import React, {useRef} from 'react';
import {Button, ButtonGroup} from 'react-bootstrap';
import moment from 'moment-timezone';
import DataTableComponent from '../../../components/DataTableComponent';
import generateRandomID from '../../../utils/generateRandomID';
import MachineCheckBox from './MachineCheckBox';

const MachineAssignmentList = (props) => {
  const {
    setCheckedAssignmentIDs,
    assignments,
    checkIDs,
    checkAllHTMLID,
    showAlertModal,
    setMachineID,
    toggleEditModal,
    hasPermission,
    modalRef,
    dtableRef,
  } = props;

  const handleEditClick = (id) => {
    setMachineID(id);
    modalRef.current.hide();
    toggleEditModal('show');
  };

  const handleDeleteClick = (id) => {
    setCheckedAssignmentIDs([id]);
    showAlertModal();
  };

  const generateCheckRef = (id, ref) => {
    if (!checkIDs.current.has(ref)) {
      checkIDs.current.set(id, ref);
    }
    return checkIDs.current.get(id);
  };

  const slotConfigs = {
    0: (data) => <MachineCheckBox {...{data, generateCheckRef}} />,
    5: (data) => (
      <div className="text-center">
        {data ? moment.tz(data, 'utc').format('YYYY-MM-DD') : '-'}
      </div>
    ),
    6: (data) => (data === 'Y' ? '是' : '否'),
    7: (data) => (data === 'Y' ? '是' : '否'),
    8: (data) =>
      hasPermission ? (
        <ButtonGroup size="sm">
          <Button
            variant="link"
            size="sm"
            onClick={() => handleEditClick(data)}
          >
            <svg className="btn__icon btn__icon--sm me-1" aria-hidden="true">
              <use href="#ico-edit"></use>
            </svg>
            編輯
          </Button>
          <Button
            variant="link"
            size="sm"
            onClick={() => handleDeleteClick(data)}
          >
            刪除
          </Button>
        </ButtonGroup>
      ) : (
        <></>
      ),
  };

  const columnConfigs = [
    {orderable: false, sortable: false, data: 'machineId'},
    {title: '交機編號', className: 'dt-center', data: 'deliveryCode'},
    {title: '機械型式', className: 'dt-center', data: 'machineModel'},
    {title: '機型名稱', className: 'dt-center', data: 'machineTypeName'},
    {title: '機械番號', className: 'dt-center', data: 'machineSerialNumber'},
    {title: '保固起始日', className: 'dt-center', data: 'deliveryDate'},
    {title: '是否轉售', className: 'dt-center', data: 'flgIsResold'},
    {title: '是否需要外勤確認', className: 'dt-center', data: 'flgOnSiteCheck'},
    {orderable: false, sortable: false, data: 'machineId'},
  ];

  return (
    <DataTableComponent
      tableRef={dtableRef}
      className="display table table-hover align-middle nowrap"
      data={assignments}
      slots={slotConfigs}
      columns={columnConfigs}
    >
      <thead>
        <tr>
          <th>
            <input
              type="checkbox"
              id={checkAllHTMLID.current}
              className="form-check-input machine-assignment-checks"
            />
          </th>
          <th>交機編號</th>
          <th>機械型式</th>
          <th>機型名稱</th>
          <th>機械番號</th>
          <th>保固起始日</th>
          <th>是否轉售</th>
          <th>是否需要外勤確認</th>
          <th></th>
        </tr>
      </thead>
    </DataTableComponent>
  );
};

export default MachineAssignmentList;
